module.exports = __webpack_public_path__ + "img/ef6b73b.jpg";